import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { environment } from 'src/environments/environment';
import { MenuIdService } from 'src/app/service/menu-id.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-activation-code',
  templateUrl: './activation-code.component.html',
  styleUrls: ['./activation-code.component.scss']
})
export class ActivationCodeComponent implements OnInit {
  activationID: any;
  showEmail: boolean = false;
  showPhone: boolean = false;
  showWhats: boolean = false;
  activationForm!: FormGroup;
  passwordForm!: FormGroup;
  isActivationForm!: FormGroup;
  whatsappActivationRequired = true;
  smsActivationRequired = true;
  emailActivationRequired = true;
  phoneCodes: any[] = [];
  showAC: boolean = false;
  showActErr: boolean = false;
  showPassErr: boolean = false;
  isPassword: boolean = false;
  userID: any;
  errMessage: any;
  activationErr: any;
  passwordErr: any;
  isActivationErr: any;
  isActivated: boolean = false;
  showIsActErr: boolean = false;
  isfullyVerified: boolean = false;
  maskedEmail: string = '';
  maskedWatsApp: string = '';
  maskedPhoneNo: string = '';
  name: string = '';
  OTPscreen: boolean = false;
  showOTPErr: boolean = false;
  orgAppId: any;
  transactionPin: boolean = false;
  showTransPassErr: boolean = false;
  showResendButton: boolean = false;
  resendCountdown: number = 60;
  resendTimer: any;
  imageURL$!: Observable<string>;
  isOrgAppMappingOnly: any;
  timer!: number;
  remainingTime!: number;
  timeRemaining_percent!: number;
  intervalId: any;
  showResend: boolean = false;
  idInvalid: boolean = false;
  supportMail: any = ''
  target: any = '_blank'
  @ViewChild('otpInput') otpInput!: ElementRef;
  emailActivationCodeReq: boolean = false;
  phoneActivationCodeReq: boolean = false;
  whatsActivationCodeReq: boolean = false;
  emailActivationCodeValidReq: boolean = false;
  phoneActivationCodeValidReq: boolean = false;
  whatsActivationCodeValidReq: boolean = false;
  otpValidReq: boolean = false;
  otpReq: boolean = false;
  MFALogin: boolean = false;
  MFATransaction: boolean = false;
  getUserActivationDetails: any;
  getCondtions: any;
  uniqueCode: any;
  imageURL:any;
  defaultWelMesg:any;
  welcomeContent:any;
  url:any;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private restService: RestService,
    private router: Router,
    private translate: TranslateService,
    private dialog: MatDialog,
    private renderer: Renderer2,
    public menuIdService: MenuIdService,
    private cookieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.activationID = params.get('id');
    });
    this.route.queryParams.subscribe(params => {
      this.url = params['redirect_url'];
    });
    this.welcomeContent = this.menuIdService.activuserContent()
    this.imageURL = this.menuIdService.getActiveImageURL();
    this.menuIdService.activuserContent().subscribe(content => {
      this.defaultWelMesg = !content;
    });
    let userSettings = window.localStorage.getItem('userSettings');
    if (userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      let lang = userSettingParsed.lang;
      if (lang) {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
      } else {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
      }
    }
    else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }

    this.activationForm = this.fb.group({
      phoneCC: ['+265'],
      watsppCC: ['+265'],
    });
    this.isActivationForm = this.fb.group({
      phoneCC: ['+265'],
      watsppCC: ['+265'],
    })
    this.passwordForm = this.fb.group({
      newpassword: ['', [
        Validators.required,
        Validators.pattern(/[a-z]/),     // At least one lowercase letter.
        Validators.pattern(/[A-Z]/),     // At least one uppercase letter.
        Validators.pattern(/\d/),        // At least one digit.
        Validators.pattern(/[@#$%^&+=]/) // At least one special character.
      ]],
      
      connewpassword: ['', [
        Validators.required,
        Validators.pattern(/[a-z]/),     // At least one lowercase letter.
        Validators.pattern(/[A-Z]/),     // At least one uppercase letter.
        Validators.pattern(/\d/),        // At least one digit.
        Validators.pattern(/[@#$%^&+=]/) // At least one special character.
      ]]
    });
    

    this.loadPhoneCodes();
    this.getActivationMethods();
    this.loader.hide();
  }

  loadPhoneCodes() {
    this.loader.show()

    this.phoneCodes = [];
    this.restService.getPhoneCode().subscribe((responsedata: any[]) => {
      this.phoneCodes = responsedata;
    });
  }

  onOtpInput(index: number, forwhat: string) {
    if (forwhat == 'Email') {
      const nextIndex = index + 1;
      if (nextIndex < 6 && this.activationForm.controls['emailotp' + index].value) {
        const input = <HTMLInputElement>document.getElementById('emailotpInput' + nextIndex);
        input.focus();
      }
    }
    if (forwhat == 'Phone') {
      const nextIndex = index + 1;
      if (nextIndex < 6 && this.activationForm.controls['phoneotp' + index].value) {
        const input = <HTMLInputElement>document.getElementById('phoneotpInput' + nextIndex);
        input.focus();
      }
    }
    if (forwhat == 'WhatsApp') {
      const nextIndex = index + 1;
      if (nextIndex < 6 && this.activationForm.controls['watsotp' + index].value) {
        const input = <HTMLInputElement>document.getElementById('watsotpInput' + nextIndex);
        input.focus();
      }
    }
  }

  setFocusOnOTPInput() {
    setTimeout(() => {
      if (this.otpInput?.nativeElement) {
        this.renderer.selectRootElement(this.otpInput.nativeElement).focus();
      }
    }, 100); // Adjust the delay as needed
  }

  getOtp(forWhat: string): string {
    let otp = '';
    if (forWhat == 'Email') {
      for (let i = 0; i < 6; i++) {
        otp += this.activationForm.controls['emailotp' + i].value;
      }
    }
    if (forWhat == 'Phone') {
      for (let i = 0; i < 6; i++) {
        otp += this.activationForm.controls['phoneotp' + i].value;
      }
    }
    if (forWhat == 'WhatsApp') {
      for (let i = 0; i < 6; i++) {
        otp += this.activationForm.controls['watsotp' + i].value;
      }
    }

    return otp;
  }

  onBackspaceKeyDown(event: KeyboardEvent, index: number, forWhat: string): void {
    if (event.key !== 'Backspace') {
      return;
    }
  
    event.preventDefault();
    let otpControlKey: string;
  
    switch (forWhat) {
      case 'Email':
        otpControlKey = 'emailotp';
        break;
      case 'Phone':
        otpControlKey = 'phoneotp';
        break;
      case 'WhatsApp':
        otpControlKey = 'watsotp';
        break;
      default:
        return;
    }
  
    const otpControl = this.activationForm.get(otpControlKey + index);
  
    if (otpControl) {
      if (index > 0) {
        const previousIndex = index - 1;
        const previousOtpControl = this.activationForm.get(forWhat.toLowerCase() + 'otp' + previousIndex);
  
        if (previousOtpControl) {
          previousOtpControl.setValue(''); // Clear the value of the previous OTP box
          const previousInputId = forWhat.toLowerCase() + 'otpInput' + previousIndex;
          const previousInputElement = document.getElementById(previousInputId) as HTMLInputElement;
  
          if (previousInputElement) {
            previousInputElement.focus(); // Focus the previous OTP box
          }
        }
      }
  
      otpControl.setValue(''); // Clear the value of the current OTP box
    }
  
    const otp = JSON.stringify(this.showEmail ? Number(this.getOtp('Email')) : null);
    const phone = JSON.stringify(this.showPhone ? Number(this.getOtp('Phone')) : null);
    const whatsApp = JSON.stringify(this.showWhats ? Number(this.getOtp('WhatsApp')) : null);
  
    if (otp === '0') {
      this.otpReq = false;
      this.otpValidReq = false;
      this.emailActivationCodeReq = false;
      this.emailActivationCodeValidReq = false;
    }
    if (phone === '0') {
      this.phoneActivationCodeReq = false;
      this.phoneActivationCodeValidReq = false;
    }
    if (whatsApp === '0') {
      this.whatsActivationCodeReq = false;
      this.whatsActivationCodeValidReq = false;
    }
  }
  

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getActivationMethods() {
    this.loader.show();
    let params = {
      "authenticationUniqueCode": this.activationID

    }
    this.restService.postUATData(params, 'api/digital/core/UserActivation/GetActivationUserDetails').subscribe(
      data => this.handleActivationResponse(data),
      error => this.handleError(error)
    );
  }

  handleActivationResponse(data: any) {
    if (data.rcode !== 200) {
      this.handleNonSuccessResponse(data);
      return;
    }

    this.processActivationDetails(data.rObj.userActivationDetails);
    this.processAuthTypesForActivation(data.rObj.authTypesForActivation);
    this.getCondtions = data.rObj.authTypesForActivation;

    this.name = data.rObj.userActivationDetails.userName || '';
    this.loader.hide();
  }

  private processActivationDetails(userActivationDetails: any) {
    this.setFocusOnOTPInput();
    this.orgAppId = userActivationDetails.orgAppID;
    this.getUserActivationDetails = userActivationDetails;

    if (!userActivationDetails.isActivationCodeVerified) {
      this.showAC = true;
    }

    if (this.checkFullyVerifiedStatus(userActivationDetails)) {
      this.isfullyVerified = true;
    }

    if (userActivationDetails.isActivationCodeVerified && !userActivationDetails.isPasswordUpdated) {
      this.userID = userActivationDetails.userGuid;
      this.isPassword = true;
    }

    if (!userActivationDetails.isMFAForLoginUpdated && userActivationDetails.isPasswordUpdated) {
      this.uniqueCode = this.activationID;
      this.MFALogin = true;
    }

    if ((userActivationDetails.isMFAForLoginUpdated || userActivationDetails.isMFAForLoginSkipped ) && userActivationDetails.isMFAForTransactionRequired && !userActivationDetails.isMFAForTransactionUpdated) {
      this.uniqueCode = this.activationID;
      this.MFATransaction = true;
    }

    if ((userActivationDetails.isMFAForLoginUpdated || userActivationDetails.isMFAForLoginSkipped) && !userActivationDetails.isMFAForTransactionRequired) {
      this.isfullyVerified = true;
    }

    if ((userActivationDetails.isMFAForLoginUpdated || userActivationDetails.isMFAForLoginSkipped)&& (userActivationDetails.isMFAForTransactionUpdated || userActivationDetails.isMFAForTransactionSkipped)) {
      this.isfullyVerified = true;
    }

    if ((userActivationDetails.isMFAForTransactionUpdated || userActivationDetails.isMFAForTransactionSkipped)) {
      this.isfullyVerified = true;
      this.transactionPin = false;
    }
  }

  private checkFullyVerifiedStatus(userActivationDetails: any): boolean {
    return (
      userActivationDetails.isActivationCodeVerified &&
      userActivationDetails.isMFAForLoginUpdated &&
      (userActivationDetails.isMFAForTransactionUpdated || !userActivationDetails.isMFAForTransactionRequired)
    );
  }


  processAuthTypesForActivation(authTypesForActivation: any) {
    authTypesForActivation.forEach((element: any) => {
      this.processAuthType(element);
    });
  }

  processAuthType(element: any) {
    switch (element.authenticationTypeID) {
      case 1000:
        this.handleEmailAuthType(element);
        break;
      case 1010:
        this.handleWhatsappAuthType(element);
        break;
      case 1020:
        this.handlePhoneAuthType(element);
        break;
      // ... other cases
    }
  }

  handleEmailAuthType(element: any) {
    if (element.isCandidateForLogin) {
      this.showEmail = true;
      this.maskedEmail = this.getUserActivationDetails.maskedEmail || '';
      this.addOTPControls('emailotp');
    }
  }

  handleWhatsappAuthType(element: any) {
    if (element.isCandidateForLogin) {
      this.showWhats = true;
      this.maskedWatsApp = this.getUserActivationDetails.maskedPhoneNumber;
      this.addOTPControls('watsotp');
    }
  }

  handlePhoneAuthType(element: any) {
    if (element.isCandidateForLogin) {
      this.showPhone = true;
      this.maskedPhoneNo = this.getUserActivationDetails.maskedPhoneNumber || '';
      this.addOTPControls('phoneotp');
    }
  }

  addOTPControls(prefix: string) {
    for (let i = 0; i < 6; i++) {
      this.activationForm.addControl(`${prefix}${i}`, new FormControl('', Validators.required));
    }
  }

  handleError(error: any) {
    this.loader.hide();
    console.error(error);
    this.loader.hide();
    if (error.error.rcode != 401 && error.error.rcode != 403
      && error.error.rcode != 404 && error.error.rcode != 500) {
      let a = error.error.rmsg[0].errorCode ?? 'ERROR'
      let err = this.translate.instant(a)
      console.error('Error Receiving data:', error);
      let _dialogRef = this.dialog.open(MatDialogComponent, {
        width: '50VW',
        disableClose: true,
        data: {
          panelClass: ['dialog-responsive'],
          disableClose: true,
          error: true,
          trnID: error.error.trnID,
          errorMessage: err ?? a
        }
      })
      _dialogRef.afterClosed().subscribe()
    }
  }

  handleNonSuccessResponse(data: any) {
    if (data.rcode == 503) {
      this.idInvalid = true;
    }
    this.loader.hide();
  }




  getActivationMessage(): string {
    let message = this.translate.instant('activation_code_sent_message') + ' ';
    const activationMethods = [];

    if (this.showEmail) {
      activationMethods.push(this.translate.instant('activation_email') + ' ' + '<strong>' + this.maskedEmail + '</strong>');
    }

    if (this.showPhone) {
      activationMethods.push(this.translate.instant('Phone_Number') + ' ' + '<strong>' + this.maskedPhoneNo + '</strong>');
    }

    if (this.showWhats) {
      activationMethods.push(this.translate.instant('whatsapp_number') + ' ' + '<strong>' + this.maskedWatsApp + '</strong>');
    }


    if (activationMethods.length > 0) {
      message += this.translate.instant('activation_code_sent_to_your') + ' ';
      if (activationMethods.length > 1) {
        const lastMethod = activationMethods.pop();
        message += activationMethods.join(', ') + ' ' + this.translate.instant('and') + ' ' + lastMethod;
      } else {
        message += activationMethods[0];
      }
      message += '.';
      message += ' ' + this.translate.instant('enter_activation_code_to_verify');
    }
    return message;
  }


  getOtpMessage(): string {
    let message = this.translate.instant('otp_code_sent_message') + ' ';
    const activationMethods = [];

    if (this.showEmail) {
      activationMethods.push(this.translate.instant('activation_email') + ' ' + '<strong>' + this.maskedEmail + '</strong>');
    }

    if (this.showPhone) {
      activationMethods.push(this.translate.instant('Phone_Number') + ' ' + '<strong>' + this.maskedPhoneNo + '</strong>');
    }

    if (this.showWhats) {
      activationMethods.push(this.translate.instant('whatsapp_number') + ' ' + '<strong>' + this.maskedWatsApp + '</strong>');
    }


    if (activationMethods.length > 0) {
      if (activationMethods.length > 1) {
        const lastMethod = activationMethods.pop();
        message += activationMethods.join(', ') + ' ' + this.translate.instant('and') + ' ' + lastMethod;
      } else {
        message += activationMethods[0];
      }
      message += '.';
      message += ' ' + this.translate.instant('enter_OTP_to_verify');
    }
    return message;
  }



  onSubmit() {
    this.showActErr = false;
    if (this.activationForm.invalid) {
      this.activationFormInvalid();
      return;
    }
    this.loader.show();
    let params = {
      "authenticationUniqueCode": this.activationID,
      "emailActivationCode": this.showEmail ? (this.getOtp('Email')) : null,
      "SMSActivationCode": this.showPhone ? (this.getOtp('Phone')) : null,
      "whatsappActivationCode": this.showWhats ? (this.getOtp('WhatsApp')) : null
    }
    this.restService.postUATData(params, 'api/digital/core/UserActivation/ValidateActivationCode').subscribe(data => {
      if (data.rcode == 200) {
        this.setFocusOnOTPInput();
        this.userID = data.rObj.userID
        this.showActErr = false;
        this.showAC = false;
        this.isPassword = true;
        this.loader.hide();
        this.showPhone = false;
        this.getActivationMethods();
      }
      else if (data.rcode == 503) {
        this.activationRcodeErrorHandle(data)
      }
      else {
        this.showActErr = false;
        this.loader.hide();
      }
    }, (error) => {
      this.loader.hide();
      this.activationStatusErrorHandle(error)
    })
  }

  private activationFormInvalid() {

    const emailOtps = ['emailotp0', 'emailotp1', 'emailotp2', 'emailotp3', 'emailotp4', 'emailotp5']; // Add all relevant emailotp control names here
    const phoneOtps = ['phoneotp0', 'phoneotp1', 'phoneotp2', 'phoneotp3', 'phoneotp4', 'phoneotp5']; // Add all relevant emailotp control names here
    const whatsappOtps = ['watsotp0', 'watsotp1', 'watsotp2', 'watsotp3', 'watsotp4', 'watsotp5']; // Add all relevant emailotp control names here

    this.emailActivationCodeReq = !emailOtps.some(control => this.activationForm.value[control] !== '');
    this.emailActivationCodeValidReq = emailOtps.some(control => this.activationForm.value[control] == '');

    if (this.emailActivationCodeReq) {
      this.emailActivationCodeReq = true;
    } else if (this.emailActivationCodeValidReq) {
      this.emailActivationCodeReq = false;
      this.emailActivationCodeValidReq = true;
    } else {
      this.emailActivationCodeValidReq = false;
    }

    this.phoneActivationCodeReq = !phoneOtps.some(control => this.activationForm.value[control] !== '');
    this.phoneActivationCodeValidReq = phoneOtps.some(control => this.activationForm.value[control] == '');

    if (this.phoneActivationCodeReq) {
      this.phoneActivationCodeReq = true;
    } else if (this.phoneActivationCodeValidReq) {
      this.phoneActivationCodeReq = false;
      this.phoneActivationCodeValidReq = true;
    } else {
      this.phoneActivationCodeValidReq = false;
    }

    this.whatsActivationCodeReq = !whatsappOtps.some(control => this.activationForm.value[control] !== '');
    this.whatsActivationCodeValidReq = whatsappOtps.some(control => this.activationForm.value[control] == '');

    if (this.whatsActivationCodeReq) {
      this.whatsActivationCodeReq = true;
    } else if (this.whatsActivationCodeValidReq) {
      this.whatsActivationCodeReq = false;
      this.whatsActivationCodeValidReq = true;
    } else {
      this.whatsActivationCodeValidReq = false;
    }

  }


  private activationRcodeErrorHandle(data: any) {

    let err = data.rmsg[0].errorCode
    this.errMessage = this.translate.instant(err)
    if (err != this.errMessage) {
      this.activationErr = this.errMessage
    }
    else {
      this.activationErr = this.translate.instant('unexpected_error')
    }
    window.scrollTo(0, 0)
    this.showActErr = true;
    this.loader.hide();

  }

  private activationStatusErrorHandle(error: any) {
    let a = error.error.rmsg[0].errorCode
    let err = this.translate.instant(a)
    this.activationErr = err
    window.scrollTo(0, 0)
    this.showActErr = true;

  }


  otpVerify() {
    this.showOTPErr = false;
    if (this.activationForm.invalid) {
      let otp = JSON.stringify(this.showEmail ? Number(this.getOtp('Email')) : null)
      if (otp.length >= 1 && otp == '0') {
        this.otpReq = true;
      } else {
        this.otpReq = false;
        this.otpValidReq = true;
      }

      return;
    }
    let otp = JSON.stringify(this.showEmail ? Number(this.getOtp('Email')) : null)

    this.loader.show();
    let params = {
      "activationUniqueIdentifier": this.activationID,
      "OTP": otp,
      "authenticationTypeID": this.getCondtions[0].activationTypeID
    }

    this.restService.postUATData(params, 'api/digital/core/UserActivation/ValidateUserActivationOTP').subscribe(data => {
      if (data.rcode == 200) {
        this.successActivationHandle(data)
      }
      else if (data.rcode == 503) {
        this.RcodeerrorHandle(data)
      }
      else {
        this.showOTPErr = false;
        this.loader.hide();
      }
    },
      (error) => {
        this.errorHandler(error);
      }
    )
  }
  private successActivationHandle(data: any) {
    this.loader.hide();
    this.isOrgAppMappingOnly = data.rObj.isOrgAppMappingOnly
    if (this.isOrgAppMappingOnly) {
      for (let i = 0; i < 6; i++) {
        const controlName = 'watsotp' + i;
        this.activationForm.removeControl(controlName);
      }
      this.getActivationMethods();
      this.activationSuccessHandle(data)
    } else {
      this.showOTPErr = false;
      this.userID = data.rObj.userID
      this.showActErr = false;
      this.showAC = false;
      this.isPassword = true;
      this.loader.hide();
      this.OTPscreen = false;
    }
  }

  private activationSuccessHandle(data: any) {
    const _dialogRef = this.dialog.open(MatDialogComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: {
        secondary: true,
        transactionReference: data.rmsg[0].transactionReference ? data.rmsg[0].transactionReference : null,
        errorMessage: this.translate.instant('Your account has been successfully activated, and you can now access your account with your existing password.')
      }
    });

    _dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/auth/login/', this.orgAppId]);
      }
    })
  }
  private RcodeerrorHandle(data: any) {
    let err = data.rmsg[0].errorCode
    this.errMessage = this.translate.instant(err)
    if (err != this.errMessage) {
      this.passwordErr = this.errMessage
    }
    else {
      this.passwordErr = this.translate.instant('unexpected_error')
    }
    this.loader.hide();
    window.scrollTo(0, 0)
    this.showOTPErr = true;
  }

  private errorHandler(error: any) {
    this.loader.hide();
    let a = error.error.rmsg[0].errorCode
    let err = this.translate.instant(a)
    this.passwordErr = err
    window.scrollTo(0, 0)
    this.showOTPErr = true;
  }



  submit() {
    this.showPassErr = false;
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched()
      return;
    }
    this.loader.show();
    let params = {
      "authenticationUniqueCode": this.activationID,
      "password": this.passwordForm.value.connewpassword
    }
    this.restService.postUATData(params, 'api/digital/core/UserActivation/UpdateActivationUserPassword').subscribe(data => {
      if (data.rcode == 200) {
        this.loader.hide();
        this.showPassErr = false;
        this.passwordForm.reset();
        this.isPassword = false;
        this.uniqueCode = this.activationID;
        this.MFALogin = true;

      }
      else if (data.rcode == 503) {
        let err = data.rmsg[0].errorCode
        this.errMessage = this.translate.instant(err)
        if (err != this.errMessage) {
          this.passwordErr = this.errMessage
        }
        else {
          this.passwordErr = this.translate.instant('unexpected_error')
        }
        this.loader.hide();
        window.scrollTo(0, 0)
        this.showPassErr = true;
      }
      else {
        this.showPassErr = false;
        this.loader.hide();
      }
    },
      (error) => {
        this.loader.hide();
        let a = error.error.rmsg[0].errorCode
        let err = this.translate.instant(a)
        this.passwordErr = err
        window.scrollTo(0, 0)
        this.showPassErr = true;
      }
    )
  }


  MFALoginSuccess(data: any) {
    if (this.getUserActivationDetails.isMFAForTransactionRequired) {
      this.getActivationMethods();
      this.MFALogin = false;
    } else {
      let supportMail = 'example@mail.com';
      let target = '_blank'
      let _dialogRef = this.dialog.open(MatDialogComponent, {
        width: '50VW',
        disableClose: true,
        data: {
          message: 'SUCCESS',
          supportMail: 'example@mail.com',
          trnID: data.rObj.transactionRef,
          errorMessage: this.translate.instant('user_password_sets')
        }
      })
      _dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.url) {
            const redirectUrl = new URL(this.url);
            const baseUrl = `${redirectUrl.protocol}//${redirectUrl.hostname}${redirectUrl.port ? ':' + redirectUrl.port : ''}`;
            window.location.href = baseUrl; 
          }
        }
      })
    }
  }

  MFATransactionSuccess(data: any) {
    if (data.rcode == 200) {
      this.MFATransaction = false;
      let supportMail = 'example@mail.com';
      let target = '_blank'
      let _dialogRef = this.dialog.open(MatDialogComponent, {
        width: '50VW',
        disableClose: true,
        data: {
          message: 'SUCCESS',
          supportMail: 'example@mail.com',
          trnID: data.rObj.transactionRef,
          errorMessage: this.translate.instant('user_password_sets')
        }
      })
      _dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.url) {
            const redirectUrl = new URL(this.url);
            const baseUrl = `${redirectUrl.protocol}//${redirectUrl.hostname}${redirectUrl.port ? ':' + redirectUrl.port : ''}`;
            window.location.href = baseUrl; 
          }
        }
      })
    } else {
      this.getActivationMethods();
    }

  }


  TransactionSubmit() {
    this.showTransPassErr = false;

    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }

    this.loader.show();
    let params = {
      "activationUniqueIdentifier": this.activationID,
      "transactionPin": this.passwordForm.value.connewpassword
    };

    this.restService.postUATData(params, 'api/digital/core/UserActivation/UpdateActivationUserTransactionPin')
      .subscribe(data => this.handleTransactionSubmitSuccess(data),
        error => this.handleTransactionSubmitError(error));
  }

  private handleTransactionSubmitSuccess(data: any) {
    this.loader.hide();

    if (data.rcode == 200) {
      this.showTransPassErr = false;
      this.handleSuccessDialog(data.rObj.transactionRef);
    } else if (data.rcode == 503) {
      this.handle503Error(data);
    } else {
      this.showTransPassErr = false;
    }
  }

  private handle503Error(data: any) {
    let err = data.rmsg[0].errorCode;
    this.errMessage = this.translate.instant(err);

    if (err != this.errMessage) {
      this.passwordErr = this.errMessage;
    } else {
      this.passwordErr = this.translate.instant('unexpected_error');
    }

    this.loader.hide();
    window.scrollTo(0, 0);
    this.showTransPassErr = true;
  }

  private handleSuccessDialog(transactionRef: string) {
    let supportMail;

    // if (this.orgAppID === 6050) {
    //   supportMail = 'support-iam@insure.digital';
    // } else if (this.orgAppID === 6100) {
    //   supportMail = 'iaz@insure.digital';
    // } else {
    //   supportMail = 'support@dmvic.com';
    // }
    supportMail = 'support@dmvic.com';

    let _dialogRef = this.dialog.open(MatDialogComponent, {
      width: '50VW',
      disableClose: true,
      data: {
        message: 'SUCCESS',
        supportMail: 'support@dmvic.com',
        trnID: transactionRef,
        errorMessage: this.translate.instant('user_password_sets')
      }
    });

    _dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const redirectUrl = this.cookieService.get('redirect_url');
        const orgAppId = this.cookieService.get('orgAppId');
        if (redirectUrl && orgAppId) {
          // Construct the URL with the parameters from cookies
          const loginUrl = `/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}&orgAppId=${encodeURIComponent(orgAppId)}`;
          // Navigate to the constructed URL
          this.router.navigateByUrl(loginUrl);
        } 
      }
    });
  }

  private handleTransactionSubmitError(error: any) {
    this.loader.hide();
    let a = error.error.rmsg[0].errorCode;
    let err = this.translate.instant(a);
    this.passwordErr = err;
    window.scrollTo(0, 0);
    this.showTransPassErr = true;
  }





  onIsActiveSubmit() {
    this.showIsActErr = false;
    this.isActivated = false;
    if (this.activationForm.invalid) {
      return;
    }
  }
  onInputChange(event: Event, forWhat: string) {
    const emailOtps = ['emailotp0', 'emailotp1', 'emailotp2', 'emailotp3', 'emailotp4', 'emailotp5']; // Add all relevant emailotp control names here
    const phoneOtps = ['phoneotp0', 'phoneotp1', 'phoneotp2', 'phoneotp3', 'phoneotp4', 'phoneotp5']; // Add all relevant emailotp control names here
    const whatsappOtps = ['watsotp0', 'watsotp1', 'watsotp2', 'watsotp', 'watsotp4', 'watsotp5']; // Add all relevant emailotp control names here
    if (emailOtps.some(control => control == forWhat)) {
      this.emailActivationCodeReq = false;
      this.emailActivationCodeValidReq = false
    }
    if (phoneOtps.some(control => control == forWhat)) {
      this.phoneActivationCodeReq = false;
      this.phoneActivationCodeValidReq = false;
    }
    if (whatsappOtps.some(control => control == forWhat)) {
      this.whatsActivationCodeReq = false;
      this.whatsActivationCodeValidReq = false;
    }
    this.otpReq = false;
    this.otpValidReq = false;
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^a-zA-Z0-9]/g, '');
    this.activationForm.controls[forWhat].setValue(inputElement.value.toUpperCase())

  }




  resendOTP() {
    this.showResendButton = false;
    this.getResendOTP();
  }

  getResendOTP() {
    this.showOTPErr = false;
    this.activationForm.reset('')

    this.loader.show();
    let params = {
      "activationUniqueIdentifier": this.activationID,
    }
    this.restService.postUATData(params, 'api/digital/core/UserActivation/ResendActivationOTP').subscribe(data => {
      if (data.rcode == 200) {
        this.loader.hide();
        this.startResendTimer();
      }
      else if (data.rcode == 503) {
        let err = data.rmsg[0].errorCode
        this.errMessage = this.translate.instant(err)
        if (err != this.errMessage) {
          this.passwordErr = this.errMessage
        }
        else {
          this.passwordErr = this.translate.instant('unexpected_error')
        }
        this.loader.hide();
        window.scrollTo(0, 0)
        this.showTransPassErr = true;
      }
      else {
        this.showTransPassErr = false;
        this.loader.hide();
      }
    },
      (error) => {
        this.loader.hide();
        let a = error.error.rmsg[0].errorCode
        let err = this.translate.instant(a)
        this.passwordErr = err
        window.scrollTo(0, 0)
        this.showTransPassErr = true;
      }
    )
  }

  resetOtp() {
    this.activationForm.reset('')
  }

  startResendTimer() {
    this.resendCountdown = 60;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
        this.showResendButton = true;
      }
    }, 1000);

  }
  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }
  goToLogin(){
    if (this.url) {
      const redirectUrl = new URL(this.url);
      const baseUrl = `${redirectUrl.protocol}//${redirectUrl.hostname}${redirectUrl.port ? ':' + redirectUrl.port : ''}`;
      window.location.href = baseUrl; 
    }
  }
}
